import envHandler from '@lima/env-handler';
import sensors from 'sa-sdk-javascript';
// const sensors_url = `${envHandler.isLocal()?'//www.test.zhongbaounion.com':window.location.origin}`+'/buried/point/client/track';

let track_url = envHandler.isStaging()?'https://sa-analysis.staging.lima-tech.com':envHandler.isProd()?'https://sa-analysis.lima-tech.com':'https://sa-analysis.test.lima-tech.com';
sensors.init({
  server_url: track_url+'/buried/point/client/track',
  show_log:true,
  heatmap: {
    scroll_notice_map: 'default', // $webStay
    clickmap: 'default', // $webClick
    collect_tags: {
      div: true
    }
  }
})
sensors.quick('autoTrack', {
	platform_type: 'PC',
    AppName: 'merchant',
})


// 页面埋点
export const sensorsAutoTrack = () => {
  sensors.quick('autoTrack', {
    platform_type: 'PC',
    AppName: 'merchant',
  });
}
// 单独页面埋点
export const sensorsSinglePage = ($title = '') => {
  sensors.quick('autoTrackSinglePage',{$title});
}
// 设置用户属性
export const sensorsSetProfile = (data = {}) => {
  const res = Object.keys(data).reduce((json = {},key = '') => {
    json['merchant_' + key] = data[key];
    return json;
  },{})
  sensors.setProfile(res);
}
/**
 * 单独事件埋点
 * @param {string} name
 * @param {*} obj
 */
export const sensorsQuick = (name = '', obj = {}) => {
  sensors.track('$WebClick',{'$element_content': name, ...obj})
}


/**
 * 自定义事件埋点(非全埋点)
 * @param {string} eventName
 * @param {*} obj
 * @param callback
 */
 export const customTrack = (eventName = '', obj = {}, callback) => {
  sensors.track(eventName, {...obj}, callback)
}

export default sensors;
